import Vue from 'vue'

export const debounce = (fn, wait = 1000) => {
  let timer
  return function(...args) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, args), wait)
  }
}

export const sendSuccessToast = (message) => {
  Vue.toasted.clear()
  Vue.toasted.success(message, {
    theme: 'toasted-primary',
    position: 'bottom-center',
    duration: 7000,
    fullWidth: true,
    singleton: true,
    keepOnHover: true,
    fitToScreen: true
  })
}


export const sendErrorToast = (err) => {
  Vue.toasted.clear()
  Vue.toasted.error(err, {
    theme: 'toasted-primary',
    position: 'bottom-center',
    duration: 7000,
    fullWidth: true,
    singleton: true,
    keepOnHover: true,
    fitToScreen: true
  })
}
